import React, { } from "react";
import Notification from "@Core/Components/Notification";
export const Header = (props) => {
  const routelist = [process.env.REACT_APP_PRODUCT_ROUTE, process.env.REACT_APP_BOOKAPPOINTMENT_ROUTE, process.env.REACT_APP_PICKDROP_ROUTE, process.env.REACT_APP_SPAREPART_ROUTE, process.env.REACT_APP_REPAIRCOST_ROUTE, process.env.REACT_APP_DIY_ROUTE, process.env.REACT_APP_SELFHELP_ROUTE, process.env.REACT_APP_SIGNLANG_ROUTE, process.env.REACT_APP_SELFHELP_REMOTESERVICE_ROUTE, process.env.REACT_APP_WARRANTYPOLICIES, process.env.REACT_APP_REQUESTSERVICE, process.env.REACT_APP_TRACKREPAIR, process.env.REACT_APP_APPOINTMENT_DETAIL, process.env.REACT_APP_EKONNECT_ROUTE,process.env.REACT_APP_PROACTIVE_CAMPAIGN]
  const handlePageRedirection = (e) => {
    e && e.preventDefault();
    let backUrl = props.isLoggedIn ? process.env.REACT_APP_BACK_BUTTON_LOGGED_IN :
      process.env.REACT_APP_BACK_BUTTON_NOTLOGGED_IN;
    if (!routelist.includes(props.pathName) && props.navMenu == "home") window.location.href = backUrl;
    else {
      props.handleNavManu(e, 'home');
      props.handlePageRoute('home');
    }
  }
  let userDetails =
    props.userData &&
      props.userData.userData &&
      props.userData.userData.userDetails &&
      props.userData.userData.userDetails
      ? props.userData.userData.userDetails
      : {};
  return (
    <>
      <div className="gnb js-mobile-open">
        <section className="epp-bar-wrap">
          <div className="epp-bar">rule
            <div className="epp-bar-div">
              <div className="epp-bar-logo"></div>
              <div className="epp-bar-msg">
                Welcome to the <div className="epp-bar-username">!</div> Please enjoy our special offers for you
              </div>
              <div className="benfit-wrap">
                <a className="benfit-wrap__benefits" href="/us/support/account/benefits/">MY BENEFITS</a>
                <span className="benfit-wrap__gap"></span>
                <a className="benfit-wrap__offers" href="/us/shop/all-deals/">SPECIAL OFFERS</a>
              </div>
            </div>
          </div>
        </section>
        <div className="gnb__dimmed" aria-hidden="true">
        </div>
        <nav className="gnb__nav" role="navigation">
          <div className="gnb__bar">
            <div className="gnb__bar-inner">
              <a href="#" an-tr="nv00_gnb--text-logo" an-ca="navigation" an-ac="gnb" onClick={handlePageRedirection}
                an-la="logo" className="gnb__logo ">
                <span className="hidden">Samsung</span>
                <div className="gnb__logo-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105 16" focusable="false">
                    <g fill="none" fillRule="evenodd">
                      <path d="M0.964 0H121.507V32H0.964z" transform="translate(-9 -8)" />
                      <path fill="#000" fillRule="nonzero"
                        d="M15.937 19.184c.155.363.104.829.026 1.114-.13.492-.466 1.01-1.45 1.01-.931 0-1.5-.544-1.5-1.347v-1.45H9v1.14C9 22.99 11.614 24 14.436 24c2.692 0 4.918-.932 5.28-3.417.181-1.295.052-2.123-.026-2.46-.62-3.133-6.29-4.065-6.73-5.8-.077-.31-.051-.62-.026-.776.104-.466.44-1.01 1.372-1.01.88 0 1.398.544 1.398 1.346v.933h3.728v-1.062C19.432 8.492 16.507 8 14.384 8c-2.666 0-4.815.88-5.229 3.314-.103.673-.13 1.269.026 2.02.673 3.028 5.98 3.909 6.756 5.85zm48.534-.025c.155.362.103.828.026 1.087-.13.492-.466.984-1.45.984-.932 0-1.475-.544-1.475-1.347V18.46h-3.96v1.139c0 3.288 2.588 4.297 5.383 4.297 2.667 0 4.867-.906 5.23-3.391.18-1.269.05-2.123-.027-2.434-.621-3.107-6.238-4.013-6.652-5.747-.078-.311-.052-.622-.026-.777.104-.466.414-.984 1.346-.984.854 0 1.372.544 1.372 1.346v.907h3.701V11.78c0-3.21-2.899-3.728-4.995-3.728-2.615 0-4.763.88-5.177 3.288-.104.647-.13 1.243.026 1.993.673 3.03 5.927 3.91 6.678 5.826zm30.984 1.32l-.207-12.013h3.701v14.757h-5.332l-3.753-12.401.207 12.401h-3.676V8.466h5.54l3.52 12.013zM28.335 9.553l-2.07 13.826h-4.038l2.744-14.913h6.652l2.744 14.913h-4.012l-2.02-13.826zm21.796 0L47.542 23.38h-3.779L41.201 9.553l-.104 13.826H37.37l.31-14.913h6.083l1.89 11.65 1.89-11.65h6.082l.337 14.913h-3.728l-.103-13.826zm26.868 11.6c1.035 0 1.372-.726 1.424-1.088.026-.156.026-.389.026-.57V8.44h3.779V19.16c0 .284-.026.828-.026.983-.259 2.797-2.46 3.703-5.203 3.703-2.744 0-4.944-.906-5.203-3.703-.026-.155-.052-.699-.026-.983V8.44h3.78v11.055c0 .181 0 .414.025.57.078.388.389 1.087 1.424 1.087zm31.165-.156c1.087 0 1.45-.7 1.527-1.088.026-.18.052-.388.026-.57v-2.174h-1.527V14.99h5.28v4.013c0 .285 0 .492-.051.984-.259 2.719-2.615 3.676-5.255 3.676-2.64 0-4.996-.957-5.254-3.676-.052-.492-.052-.699-.052-.984v-6.291c0-.259.026-.725.052-.984.336-2.796 2.588-3.676 5.254-3.676 2.64 0 4.97.88 5.229 3.676.052.466.026.984.026.984v.492h-3.78v-.829s0-.362-.051-.57c-.078-.336-.362-1.087-1.501-1.087-1.088 0-1.398.725-1.476 1.088-.052.207-.052.466-.052.699v6.835c0 .181 0 .388.026.57.104.414.492 1.087 1.58 1.087z"
                        transform="translate(-9 -8)" />
                    </g>
                  </svg>
                </div>
              </a>


              <div className="gnb__mobile-menu">
                {props.isLoggedIn && <Notification {...props}/>}

                <a href="https://www.samsung.com/in/web/cart/" className="gnb__cart-btn js-gp-cart-btn"
                  role="button" an-tr="nv00_gnb--cart-depth1" an-ca="navigation" an-ac="gnb" an-la="cart">
                  <span className="hidden">Cart</span>
                  <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"
                    focusable="false">
                    <path
                      d="M72.848 70.25c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-35 0c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11c0-6.074 4.926-11 11-11zm35 7a4 4 0 10.002 8.001 4 4 0 00-.002-8.001zm-35 0a4 4 0 100 8 4 4 0 000-8zM13.892 3.75c2.287 0 4.376 1.55 5.058 3.72l.064.22 2.97 11.187h68.128a4.727 4.727 0 014.661 5.786l-.048.2-9.559 36.291c-.583 2.216-2.618 3.842-4.894 3.944l-.228.005H30.06c-2.287 0-4.377-1.55-5.06-3.72l-.063-.219-13.124-49.413-10.7.006-.004-8 12.782-.007zm72.03 23.127H24.108l8.027 30.226H77.96l7.962-30.226z">
                    </path>
                  </svg>
                  <span className="gnb__cart-in-number gnb-cart-count" aria-live="polite"
                    style={{ display: 'none' }}></span>
                </a>

                <a className="gnb__menu-btn js-gnb-menu-btn" href="#" onClick={e => e.preventDefault()} aria-haspopup="true"
                  role="button" an-tr="nv00_gnb--image-action" an-ca="navigation" an-ac="gnb"
                  an-la="gnb:open" aria-expanded="false"><span>Open Menu</span>
                  <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"
                    focusable="false">
                    <path d="M83 70v8H13v-8h70zm0-26v8H13v-8h70zm0-26v8H13v-8h70z"></path>
                  </svg>
                </a>
              </div>

              <div className="gnb__menu-wrap">
                <div className="gnb__depth1-container">
                  <div className="gnb__main">

                    <ul className="gnb__depth1" role="menubar">
                      <li className="gnb__depth1-menu has-depth-menu" role="presentation">
                        <a className="gnb__depth1-link" href="#" onClick={e => e.preventDefault()} role="menuitem"
                          data-engname="mobile" aria-expanded="false" aria-haspopup="true">
                          <span className="gnb__depth1-link-text">Mobile</span>
                          <svg className="icon icon--next" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 96 96" focusable="false">
                            <path
                              d="M35.757 84.389l-5.533-5.778 31.982-30.612L30.224 17.39l5.533-5.779 38.018 36.388z">
                            </path>
                          </svg>
                        </a>
                        <div className="gnb__depth2-wrap">
                          <div className="gnb__depth-back-wrap">
                            <a className="gnb__depth-back" href="#" onClick={e => e.preventDefault()}>
                              <svg className="icon icon--back" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M40.544 11.613l5.538 5.774L18.335 44l75.054.001v8H18.337l27.745 26.612-5.538 5.774L2.611 48l37.933-36.387z">
                                </path>
                              </svg>
                              <span className="hidden">Back to 1 Depth Menu</span>
                            </a>
                          </div>
                          <div className="gnb__depth2-inner" aria-hidden="true">
                            <div className="gnb__depth2-title-wrap">
                              <strong className="gnb__depth2-title">


                                <a className="gnb__depth2-title-link"
                                  href="https://www.samsung.com/in/mobile/"
                                  an-tr="nv00_gnb--click-depth1" an-ca="navigation"
                                  an-ac="gnb" an-la="mobile:mobile">Mobile</a>


                              </strong>
                            </div>
                            <ul className="gnb__depth2" role="menu">

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="mobile:new and featured"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    New &amp; Featured

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/galaxy-z-flip4/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:new and featured:galaxy z flip4">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Z Flip4

                                            <span
                                              className="badge-icon badge-icon--label badge-icon--bg-color-blue">NEW</span>
                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/galaxy-z-fold4/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:new and featured:galaxy z fold4">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Z Fold4

                                            <span
                                              className="badge-icon badge-icon--label badge-icon--bg-color-blue">NEW</span>
                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/watches/galaxy-watch/galaxy-watch5-44mm-graphite-bluetooth-sm-r910nzaainu/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:new and featured:galaxy watch5">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Watch5

                                            <span
                                              className="badge-icon badge-icon--label badge-icon--bg-color-blue">NEW</span>
                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/watches/galaxy-watch/galaxy-watch5-pro-black-titanium-bluetooth-sm-r920nzkainu/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:new and featured:galaxy watch5 pro">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Watch5 Pro

                                            <span
                                              className="badge-icon badge-icon--label badge-icon--bg-color-blue">NEW</span>
                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-sound/galaxy-buds/galaxy-buds2-pro-bora-purple-sm-r510nlvainu/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:new and featured:galaxy buds2 pro">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Buds2 Pro

                                            <span
                                              className="badge-icon badge-icon--label badge-icon--bg-color-blue">NEW</span>
                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-type-code="20010000" data-group-code="20000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="mobile:smartphones"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Smartphones

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:smartphones:discover smartphones">
                                          <span className="gnb__depth3-link-text">
                                            Discover Smartphones

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/galaxy-z/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:smartphones:galaxy z">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Z

                                            <span
                                              className="badge-icon badge-icon--label badge-icon--bg-color-blue">NEW</span>
                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/galaxy-s/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:smartphones:galaxy s">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy S

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/galaxy-a-series/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:smartphones:galaxy a">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy A

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/galaxy-m/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:smartphones:galaxy m">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy M

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/galaxy-f/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:smartphones:galaxy f">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy F

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/mobile-accessories/all-mobile-accessories/?smartphones"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:smartphones:accessories">
                                          <span className="gnb__depth3-link-text">
                                            Accessories

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/all-smartphones/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:smartphones:all smartphones">
                                          <span className="gnb__depth3-link-text">
                                            All Smartphones

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/compare/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:smartphones:compare">
                                          <span className="gnb__depth3-link-text">
                                            Compare

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-type-code="20020000" data-group-code="20000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="mobile:tablets"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Tablets

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tablets/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:tablets:discover tablets">
                                          <span className="gnb__depth3-link-text">
                                            Discover Tablets

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tablets/galaxy-tab-s/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:tablets:galaxy tab s">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Tab S

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tablets/galaxy-tab-a/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:tablets:galaxy tab a">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Tab A

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/mobile-accessories/all-mobile-accessories/?tabs"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:tablets:accessories">
                                          <span className="gnb__depth3-link-text">
                                            Accessories

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tablets/all-tablets/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:tablets:all tablets">
                                          <span className="gnb__depth3-link-text">
                                            All Tablets

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tablets/compare/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:tablets:compare">
                                          <span className="gnb__depth3-link-text">
                                            Compare

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-type-code="20030000" data-group-code="20000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="mobile:watches"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Watches

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/watches/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:watches:discover watches">
                                          <span className="gnb__depth3-link-text">
                                            Discover Watches

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/watches/galaxy-watch/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:watches:galaxy watch">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Watch

                                            <span
                                              className="badge-icon badge-icon--label badge-icon--bg-color-blue">NEW</span>
                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/mobile-accessories/all-mobile-accessories/?watch-straps"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:watches:accessories">
                                          <span className="gnb__depth3-link-text">
                                            Accessories

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/watches/all-watches/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:watches:all watches">
                                          <span className="gnb__depth3-link-text">
                                            All Watches

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/watches/compare/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:watches:compare">
                                          <span className="gnb__depth3-link-text">
                                            Compare

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="mobile:galaxy buds"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Galaxy Buds

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-sound/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:galaxy buds:discover galaxy buds">
                                          <span className="gnb__depth3-link-text">
                                            Discover Galaxy Buds

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-sound/galaxy-buds/galaxy-buds2-pro-bora-purple-sm-r510nlvainu/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:galaxy buds:galaxy buds2 pro">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Buds2 Pro

                                            <span
                                              className="badge-icon badge-icon--label badge-icon--bg-color-blue">NEW</span>
                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-sound/galaxy-buds/galaxy-buds2-white-sm-r177nzwainu/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:galaxy buds:galaxy buds2">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Buds2

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-sound/all-audio-sound/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:galaxy buds:all audio sound">
                                          <span className="gnb__depth3-link-text">
                                            All Audio Sound

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-sound/compare/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:galaxy buds:compare">
                                          <span className="gnb__depth3-link-text">
                                            Compare

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-type-code="20060000" data-group-code="20000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="mobile:accessories"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Accessories

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/mobile-accessories/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:accessories:discover accessories">
                                          <span className="gnb__depth3-link-text">
                                            Discover Accessories

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/mobile-accessories/all-mobile-accessories/?smartphones"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:accessories:smartphone accessories">
                                          <span className="gnb__depth3-link-text">
                                            Smartphone Accessories

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/mobile-accessories/all-mobile-accessories/?tablets"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:accessories:tablet accessories">
                                          <span className="gnb__depth3-link-text">
                                            Tablet Accessories

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/mobile-accessories/all-mobile-accessories/?watches"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:accessories:watch accessories">
                                          <span className="gnb__depth3-link-text">
                                            Watch Accessories

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/mobile-accessories/all-mobile-accessories/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:accessories:all accessories">
                                          <span className="gnb__depth3-link-text">
                                            All Accessories

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="mobile:one ui"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    One UI

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/one-ui/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:one ui:one ui overview">
                                          <span className="gnb__depth3-link-text">
                                            One UI Overview

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/mobile/connected-experience/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:one ui:connected experience">
                                          <span className="gnb__depth3-link-text">
                                            Connected Experience

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="mobile:apps &amp; services"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Apps &amp; Services

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/apps/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:apps &amp; services:apps and services overview">
                                          <span className="gnb__depth3-link-text">
                                            Apps &amp; Services Overview

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/apps/galaxy-store/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:apps &amp; services:galaxy store">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Store

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/apps/bixby/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:apps &amp; services:bixby">
                                          <span className="gnb__depth3-link-text">
                                            Bixby

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/samsung-pay/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:apps &amp; services:samsung pay">
                                          <span className="gnb__depth3-link-text">
                                            Samsung Pay

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/apps/samsung-dex/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:apps &amp; services:samsung dex">
                                          <span className="gnb__depth3-link-text">
                                            Samsung DeX

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/apps/samsung-members/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:apps &amp; services:samsung members">
                                          <span className="gnb__depth3-link-text">
                                            Samsung Members

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/apps/smart-switch/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:apps &amp; services:smart switch">
                                          <span className="gnb__depth3-link-text">
                                            Smart Switch

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microsite/my-galaxy/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:apps &amp; services:my galaxy">
                                          <span className="gnb__depth3-link-text">
                                            My Galaxy

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>






                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/mobile/why-galaxy/"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb" an-la="mobile:why galaxy"
                                  aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Why Galaxy

                                  </span>
                                </a>

                              </li>

                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/offer/samsung-care-plus/"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="mobile:samsung care plus" aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Samsung Care+

                                  </span>
                                </a>

                              </li>


                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="mobile:e-catalogue"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    e-catalogue

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/galaxyzsnote/r.html?source=dotcom&showcon=0&bn=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:e-catalogue:galaxy z | galaxy s | galaxy note">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Z | Galaxy S | Galaxy Note
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/galaxya/r.html?source=dotcom&showcon=0&bn=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:e-catalogue:galaxy a">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy A
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/galaxym/r.html?source=dotcom&showcon=0&bn=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:e-catalogue:galaxy m">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy M
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/galaxyf/r.html?bn=1&source=dotcom"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:e-catalogue:galaxy f">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy F
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/tabwearables/r.html?source=dotcom&showcon=0&bn=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="mobile:e-catalogue:tablets | wearables ">
                                          <span className="gnb__depth3-link-text">
                                            Tablets | Wearables
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>


                            </ul>
                            <div className="gnb__feature-container">
                              <a className="gnb__feature-container-link"
                                href="https://www.samsung.com/in/smartphones/galaxy-z-fold4/buy/?modelCode=SM-F936BZAH"
                                an-tr="nv00_gnb--cta-feature" an-ca="navigation" an-ac="gnb"
                                an-la="feature image:mobile:galaxy z fold4 | z flip4:buy now">
                                <div className="image">
                                  <img className="image__preview responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/home/GNB_624x6243.jpg?$LazyLoad_Home_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/home/GNB_624x6243.jpg?$LazyLoad_Home_JPG$"
                                    alt="Galaxy Z Fold4 | Z Flip4"
                                    src="https://images.samsung.com/is/image/samsung/assets/in/home/GNB_624x6243.jpg" />
                                  <img className="image__main responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/home/GNB_624x6243.jpg?$330_330_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/home/GNB_624x6243.jpg?$624_624_JPG$"
                                    alt="Galaxy Z Fold4 | Z Flip4" src="https://images.samsung.com/is/image/samsung/assets/in/home/GNB_624x6243.jpg" />
                                </div>
                                <div className="gnb__feature-container-contents">
                                  <p className="gnb__feature-container-description">Galaxy Z
                                    Fold4 | Z Flip4</p>
                                  <span className="cta cta--underline cta--black">Buy
                                    now</span>
                                </div>
                              </a>

                            </div>
                            <a className="gnb__depth2-close" href="#" onClick={e => e.preventDefault()} role="button"
                              an-tr="nv00_gnb--image-action" an-ca="navigation" an-ac="gnb"
                              an-la="gnb:close">
                              <span className="hidden">Close Menu</span>
                              <svg className="icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z">
                                </path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </li>

                      <li className="gnb__depth1-menu has-depth-menu" role="presentation">
                        <a className="gnb__depth1-link" href="#" onClick={e => e.preventDefault()} role="menuitem"
                          data-engname="tv and av" aria-expanded="false" aria-haspopup="true">
                          <span className="gnb__depth1-link-text">TV &amp; AV</span>
                          <svg className="icon icon--next" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 96 96" focusable="false">
                            <path
                              d="M35.757 84.389l-5.533-5.778 31.982-30.612L30.224 17.39l5.533-5.779 38.018 36.388z">
                            </path>
                          </svg>
                        </a>
                        <div className="gnb__depth2-wrap">
                          <div className="gnb__depth-back-wrap">
                            <a className="gnb__depth-back" href="#" onClick={e => e.preventDefault()}>
                              <svg className="icon icon--back" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M40.544 11.613l5.538 5.774L18.335 44l75.054.001v8H18.337l27.745 26.612-5.538 5.774L2.611 48l37.933-36.387z">
                                </path>
                              </svg>
                              <span className="hidden">Back to 1 Depth Menu</span>
                            </a>
                          </div>
                          <div className="gnb__depth2-inner" aria-hidden="true">
                            <div className="gnb__depth2-title-wrap">
                              <strong className="gnb__depth2-title">

                                <span className="gnb__depth2-title-text">TV &amp; AV</span>


                              </strong>
                            </div>
                            <ul className="gnb__depth2" role="menu">

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="tv and av:new and featured"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    New &amp; Featured

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/all-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:new and featured:all tvs">
                                          <span className="gnb__depth3-link-text">
                                            All TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/qled-tv/?qled-8k+neo-qled"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:new and featured:neo qled 8k">
                                          <span className="gnb__depth3-link-text">
                                            Neo QLED 8K

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/projectors/the-freestyle/lsp3b-the-freestyle-sp-lsp3blaxxl/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:new and featured:the freestyle">
                                          <span className="gnb__depth3-link-text">
                                            The Freestyle

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/qled-tv/?qled-4k"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:new and featured:qled 4k">
                                          <span className="gnb__depth3-link-text">
                                            QLED 4K

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/qled-tv/?neo-qled+qled-4k"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:new and featured:neo qled">
                                          <span className="gnb__depth3-link-text">
                                            Neo QLED

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/lifestyle-tvs/the-frame/ls03b-55-inch-the-frame-qled-4k-smart-tv-black-qa55ls03baklxl/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:new and featured:the frame">
                                          <span className="gnb__depth3-link-text">
                                            The Frame

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/uhd-4k-tv/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:new and featured:uhd tv">
                                          <span className="gnb__depth3-link-text">
                                            UHD TV

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/lifestyle-tvs/the-serif/the-serif-50-inch-4k-smart-tv-ls01t-white-qa50ls01taklxl/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:new and featured:the serif">
                                          <span className="gnb__depth3-link-text">
                                            The Serif

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/smart-tv/highlights/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:new and featured:smart tv">
                                          <span className="gnb__depth3-link-text">
                                            Smart TV

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-devices/soundbar/?q-series"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:new and featured:sound bar q series ">
                                          <span className="gnb__depth3-link-text">
                                            Sound bar Q Series

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-type-code="21010000" data-group-code="21000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="tv and av:tvs"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    TVs

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/all-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tvs:all tvs">
                                          <span className="gnb__depth3-link-text">
                                            All TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/all-tvs/?qled-8k"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tvs:qled 8k">
                                          <span className="gnb__depth3-link-text">
                                            QLED 8K

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/qled-tv/?qled-4k"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tvs:qled 4k">
                                          <span className="gnb__depth3-link-text">
                                            QLED 4K

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/uhd-4k-tv/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tvs:uhd 4k">
                                          <span className="gnb__depth3-link-text">
                                            UHD 4K

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/full-hd-tv/?full-hd-tv+hd-tv"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tvs:full hd and hd tvs">
                                          <span className="gnb__depth3-link-text">
                                            Full HD/HD TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/all-tvs/?yes"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tvs:smart tvs">
                                          <span className="gnb__depth3-link-text">
                                            Smart TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tv-accessories/all-tv-accessories/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tvs:tv accessories">
                                          <span className="gnb__depth3-link-text">
                                            TV Accessories

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tvs:discover tvs">
                                          <span className="gnb__depth3-link-text">
                                            Discover TVs

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-type-code="21050000" data-group-code="21000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="tv and av:lifestyle tvs"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Lifestyle TVs

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/lifestyle-tvs/all-lifestyle-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:lifestyle tvs:all lifestyle tvs">
                                          <span className="gnb__depth3-link-text">
                                            All Lifestyle TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/lifestyle-tvs/the-frame/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:lifestyle tvs:the frame">
                                          <span className="gnb__depth3-link-text">
                                            The Frame

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/lifestyle-tvs/the-serif/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:lifestyle tvs:the serif">
                                          <span className="gnb__depth3-link-text">
                                            The Serif

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/lifestyle-tvs/the-sero/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:lifestyle tvs:the sero">
                                          <span className="gnb__depth3-link-text">
                                            The Sero

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tv-accessories/all-tv-accessories/?bezel"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:lifestyle tvs:lifestyle tv accessories">
                                          <span className="gnb__depth3-link-text">
                                            Lifestyle TV Accessories

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/lifestyle-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:lifestyle tvs:discover lifestyle tvs">
                                          <span className="gnb__depth3-link-text">
                                            Discover Lifestyle TVs

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="tv and av:projectors"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Projectors

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/projectors/all-projectors/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:projectors:all projectors">
                                          <span className="gnb__depth3-link-text">
                                            All Projectors

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/projectors/the-freestyle/lsp3b-the-freestyle-sp-lsp3blaxxl/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:projectors:freestyle">
                                          <span className="gnb__depth3-link-text">
                                            The Freestyle

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/projectors/all-projectors/?the-premiere"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:projectors:the premier">
                                          <span className="gnb__depth3-link-text">
                                            The Premier

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-group-code="21000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="tv and av:tv by size"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    TV by Size

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/80cm-32-inch-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tv by size:80cm (32&#34;) tvs">
                                          <span className="gnb__depth3-link-text">
                                            80cm (32&quot;) TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/1m-08cm-43-inch-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tv by size:1m 08cm (43&#34;) tvs">
                                          <span className="gnb__depth3-link-text">
                                            1m 08cm (43&quot;) TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/1m-25cm-50-inch-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tv by size:1m 25cm (50&#34;) tvs">
                                          <span className="gnb__depth3-link-text">
                                            1m 25cm (50&quot;) TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/1m-38cm-55-inch-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tv by size:1m 38cm (55&#34;) tvs">
                                          <span className="gnb__depth3-link-text">
                                            1m 38cm (55&quot;) TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/1m-63cm-65-inch-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tv by size:1m 63cm (65&#34;) tvs">
                                          <span className="gnb__depth3-link-text">
                                            1m 63cm (65&quot;) TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/1m-89cm-75-inch-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tv by size:1m 89cm (75&#34;) tvs">
                                          <span className="gnb__depth3-link-text">
                                            1m 89cm (75&quot;) TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/2m-16cm-85-inch-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tv by size:2m 16cm (85&#34;) tvs">
                                          <span className="gnb__depth3-link-text">
                                            2m 16cm (85&quot;) TVs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/all-tvs/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:tv by size:all tv by size">
                                          <span className="gnb__depth3-link-text">
                                            All TV by Size

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-group-code="21000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="tv and av:sound devices"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Sound Devices

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-devices/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:sound devices:discover sound devices">
                                          <span className="gnb__depth3-link-text">
                                            Discover Sound Devices

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-devices/soundbar/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:sound devices:soundbar">
                                          <span className="gnb__depth3-link-text">
                                            Soundbar

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-devices/sound-tower/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:sound devices:sound tower">
                                          <span className="gnb__depth3-link-text">
                                            Sound Tower

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-devices/all-audio-devices/?others"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:sound devices:home entertainment system">
                                          <span className="gnb__depth3-link-text">
                                            Home Entertainment System

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-devices/all-audio-devices/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:sound devices:all sound devices">
                                          <span className="gnb__depth3-link-text">
                                            All Sound Devices
                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>
                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/care-pack/all-care-pack/?televisions-care-pack"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="tv and av:care packs" aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Care Packs

                                  </span>
                                </a>

                              </li>

                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/tvs/tv-buying-guide/"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="tv and av:all about tv" aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    All About TV

                                  </span>
                                </a>

                              </li>


                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="tv and av:e-catalogue"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    e-catalogue

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/tvandsound/r.html?source=dotcom&showcon=0&bn=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="tv and av:e-catalogue:television | sound devices">
                                          <span className="gnb__depth3-link-text">
                                            Television | Sound Devices
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>


                            </ul>
                            <div className="gnb__feature-container">
                              <a className="gnb__feature-container-link"
                                href="https://www.samsung.com/in/tvs/all-tvs/?neo-qled-offer"
                                an-tr="nv00_gnb--cta-feature" an-ca="navigation" an-ac="gnb"
                                an-la="feature image:tv and av:let&#39;s do neo qled 8k:buy now">
                                <div className="image">
                                  <img className="image__preview responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/GNB-Neo_QLED_Launch_624x624.jpg?$LazyLoad_Home_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/GNB-Neo_QLED_Launch_624x624.jpg?$LazyLoad_Home_JPG$"
                                    alt="Let&#39;s Do Neo QLED 8K"
                                    src="https://images.samsung.com/is/image/samsung/assets/in/gnb/GNB-Neo_QLED_Launch_624x624.jpg" />
                                  <img className="image__main responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/GNB-Neo_QLED_Launch_624x624.jpg?$330_330_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/GNB-Neo_QLED_Launch_624x624.jpg?$624_624_JPG$"
                                    alt="Let&#39;s Do Neo QLED 8K" src="https://images.samsung.com/is/image/samsung/assets/in/gnb/GNB-Neo_QLED_Launch_624x624.jpg" />
                                </div>
                                <div className="gnb__feature-container-contents">
                                  <p className="gnb__feature-container-description">Let&#39;s
                                    Do Neo QLED 8K</p>
                                  <span className="cta cta--underline cta--black">Buy
                                    now</span>
                                </div>
                              </a>

                            </div>
                            <a className="gnb__depth2-close" href="#" onClick={e => e.preventDefault()} role="button"
                              an-tr="nv00_gnb--image-action" an-ca="navigation" an-ac="gnb"
                              an-la="gnb:close">
                              <span className="hidden">Close Menu</span>
                              <svg className="icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z">
                                </path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </li>

                      <li className="gnb__depth1-menu has-depth-menu" role="presentation">
                        <a className="gnb__depth1-link" href="#" onClick={e => e.preventDefault()} role="menuitem"
                          data-engname="home appliances" aria-expanded="false"
                          aria-haspopup="true">
                          <span className="gnb__depth1-link-text">Home Appliances</span>
                          <svg className="icon icon--next" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 96 96" focusable="false">
                            <path
                              d="M35.757 84.389l-5.533-5.778 31.982-30.612L30.224 17.39l5.533-5.779 38.018 36.388z">
                            </path>
                          </svg>
                        </a>
                        <div className="gnb__depth2-wrap">
                          <div className="gnb__depth-back-wrap">
                            <a className="gnb__depth-back" href="#" onClick={e => e.preventDefault()}>
                              <svg className="icon icon--back" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M40.544 11.613l5.538 5.774L18.335 44l75.054.001v8H18.337l27.745 26.612-5.538 5.774L2.611 48l37.933-36.387z">
                                </path>
                              </svg>
                              <span className="hidden">Back to 1 Depth Menu</span>
                            </a>
                          </div>
                          <div className="gnb__depth2-inner" aria-hidden="true">
                            <div className="gnb__depth2-title-wrap">
                              <strong className="gnb__depth2-title">


                                <a className="gnb__depth2-title-link"
                                  href="https://www.samsung.com/in/home-appliances/"
                                  an-tr="nv00_gnb--click-depth1" an-ca="navigation"
                                  an-ac="gnb" an-la="home appliances:home appliances">Home
                                  Appliances</a>


                              </strong>
                            </div>
                            <ul className="gnb__depth2" role="menu">

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="home appliances:new and featured"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    New &amp; Featured

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/air-conditioners/split-ac/?wind-free"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:windfree ac">
                                          <span className="gnb__depth3-link-text">
                                            WindFree AC

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/double-door/?available-to-order+curd-maestro"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:curd maestro refrigerators">
                                          <span className="gnb__depth3-link-text">
                                            Curd Maestro™ Refrigerators

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/vacuum-cleaners/stick/vs9000rl-super-powerful-clean-silver-vs20r9046t3-tl/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:jet™  vacuum cleaner">
                                          <span className="gnb__depth3-link-text">
                                            Jet™ Vacuum Cleaner

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/all-washers-and-dryers/?washer-dryer+front-loading"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:ecobubble washer &amp; dryer">
                                          <span className="gnb__depth3-link-text">
                                            Ecobubble Washer &amp; Dryer

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/dishwashers/all-dishwashers/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:intensivewash tm dishwasher">
                                          <span className="gnb__depth3-link-text">
                                            IntensiveWash™ Dishwasher

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/all-refrigerators/?bespoke"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:bespoke refrigerators">
                                          <span className="gnb__depth3-link-text">
                                            BESPOKE Refrigerators

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/one-door/?digi-touch-cool"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:digi-touch cool 5in1 refrigerators">
                                          <span className="gnb__depth3-link-text">
                                            Digi-Touch Cool™ 5in1 Refrigerators

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/side-by-side/rs5000rc-family-hub-673l-black-rs72a5fc1b4-tl/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:curd maestro™ family hub™ refrigerator">
                                          <span className="gnb__depth3-link-text">
                                            Curd Maestro™ Family Hub™
                                            Refrigerator

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/all-washers-and-dryers/?top-loading"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:eco fabric care washing machines">
                                          <span className="gnb__depth3-link-text">
                                            Eco Fabric Care Washing Machines

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microsite/airdresser/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:airdresser">
                                          <span className="gnb__depth3-link-text">
                                            AirDresser

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microsite/convertible-5-in-1-ac/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:convertible 5 in 1 ac">
                                          <span className="gnb__depth3-link-text">
                                            Convertible 5 in 1 AC<br />

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/home-appliances/healthy-home/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:new and featured:stay home stay happy">
                                          <span className="gnb__depth3-link-text">
                                            Stay home, stay happy

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-type-code="25020000" data-group-code="25000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="home appliances:refrigerators"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Refrigerators

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/all-refrigerators/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:refrigerators:all refrigerators">
                                          <span className="gnb__depth3-link-text">
                                            All Refrigerators

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/all-refrigerators/?bespoke"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:refrigerators:bespoke refrigerators">
                                          <span className="gnb__depth3-link-text">
                                            BESPOKE Refrigerators

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/french-door/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:refrigerators:french door">
                                          <span className="gnb__depth3-link-text">
                                            French Door

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/side-by-side/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:refrigerators:side by side">
                                          <span className="gnb__depth3-link-text">
                                            Side by Side

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/double-door/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:refrigerators:double door">
                                          <span className="gnb__depth3-link-text">
                                            Double Door

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/one-door/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:refrigerators:single door">
                                          <span className="gnb__depth3-link-text">
                                            Single Door

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:refrigerators:discover refrigerators">
                                          <span className="gnb__depth3-link-text">
                                            Discover Refrigerators

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/home-appliances/buying-guide/refrigerators/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:refrigerators:buying guides">
                                          <span className="gnb__depth3-link-text">
                                            Buying Guides

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="home appliances:washing machines &amp; dryers"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Washing Machines &amp; Dryers


                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/all-washers-and-dryers/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:washing machines &amp; dryers:all washing machines &amp; dryers">
                                          <span className="gnb__depth3-link-text">
                                            All Washing Machines &amp; Dryers

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/washing-machines/?front-loading"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:washing machines &amp; dryers:front load">
                                          <span className="gnb__depth3-link-text">
                                            Front Load

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/washing-machines/?top-loading"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:washing machines &amp; dryers:top load">
                                          <span className="gnb__depth3-link-text">
                                            Top Load

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/washing-machines/?semi-automatic"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:washing machines &amp; dryers:semi automatic">
                                          <span className="gnb__depth3-link-text">
                                            Semi Automatic

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/washer-dryer-combo/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:washing machines &amp; dryers:washer-dryer">
                                          <span className="gnb__depth3-link-text">
                                            Washer-Dryer

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/all-washers-and-dryers/?dryers"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:washing machines &amp; dryers:dryers">
                                          <span className="gnb__depth3-link-text">
                                            Dryers<br />

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:washing machines &amp; dryers:discover washing machines &amp; dryers">
                                          <span className="gnb__depth3-link-text">
                                            Discover Washing Machines &amp;
                                            Dryers

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/home-appliances/buying-guide/washing-machines/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:washing machines &amp; dryers:buying guides">
                                          <span className="gnb__depth3-link-text">
                                            Buying Guides

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="home appliances:air conditioners"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Air Conditioners

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/air-conditioners/all-air-conditioners/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:air conditioners:all air conditioners">
                                          <span className="gnb__depth3-link-text">
                                            All Air Conditioners

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/air-conditioners/split-ac/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:air conditioners:split ac">
                                          <span className="gnb__depth3-link-text">
                                            Split AC

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>






                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/washers-and-dryers/all-washers-and-dryers/?air-dresser"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="home appliances:airdresser "
                                  aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    AirDresser

                                  </span>
                                </a>

                              </li>


                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-type-code="25030000" data-group-code="25000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="home appliances:cooking appliances"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Cooking Appliances

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/cooking-appliances/all-cooking-appliances/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:cooking appliances:all cooking appliances">
                                          <span className="gnb__depth3-link-text">
                                            All Cooking Appliances

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microwave-ovens/convection/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:cooking appliances:convection microwave ovens">
                                          <span className="gnb__depth3-link-text">
                                            Convection Microwave Ovens

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microwave-ovens/grill/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:cooking appliances:grill microwave ovens">
                                          <span className="gnb__depth3-link-text">
                                            Grill Microwave Ovens

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microwave-ovens/solo/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:cooking appliances:solo microwave ovens">
                                          <span className="gnb__depth3-link-text">
                                            Solo Microwave Ovens

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/cooking-appliances/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:cooking appliances:discover cooking appliances">
                                          <span className="gnb__depth3-link-text">
                                            Discover Cooking Appliances

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/home-appliances/buying-guide/microwaves/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:cooking appliances:buying guides">
                                          <span className="gnb__depth3-link-text">
                                            Buying Guides

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>






                              <li className="gnb__depth2-menu" role="presentation"
                                data-type-code="08090000" data-group-code="08000000">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/dishwashers/all-dishwashers/"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="home appliances:dishwashers"
                                  aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Dishwashers

                                  </span>
                                </a>

                              </li>

                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/vacuum-cleaners/all-vacuum-cleaners/"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="home appliances:vacuum cleaners"
                                  aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Vacuum Cleaners

                                  </span>
                                </a>

                              </li>


                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="home appliances:air purifier "
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Air Purifier

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/air-care/air-purifier/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:air purifier :all air purifier">
                                          <span className="gnb__depth3-link-text">
                                            All Air Purifier

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/home-appliance-accessories/?air-purifier-accessories/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:air purifier :all accessories">
                                          <span className="gnb__depth3-link-text">
                                            All Accessories

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-group-code="25000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="home appliances:care packs"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Care Packs

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/care-pack/all-care-pack/?refrigerators-care-pack"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:care packs:refrigerator care packs">
                                          <span className="gnb__depth3-link-text">
                                            Refrigerator Care Packs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/care-pack/all-care-pack/?cooking-appliances-care-pack"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:care packs:cooking appliance care packs">
                                          <span className="gnb__depth3-link-text">
                                            Cooking Appliance Care Packs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/care-pack/all-care-pack/?washers-and-dryers-care-pack"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:care packs:washing machine care packs">
                                          <span className="gnb__depth3-link-text">
                                            Washing Machine Care Packs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/care-pack/all-care-pack/?air-conditioners-care-pack"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:care packs:air conditioner care packs">
                                          <span className="gnb__depth3-link-text">
                                            Air Conditioner Care Packs

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="home appliances:e-catalogue"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    e-catalogue

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/refrigerator/r.html?source=dotcom&showcon=0&bn=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:e-catalogue:refrigerators">
                                          <span className="gnb__depth3-link-text">
                                            Refrigerators
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/washingmachines/r.html?source=dotcom&showcon=0&bn=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:e-catalogue:washing machines">
                                          <span className="gnb__depth3-link-text">
                                            Washing Machines
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/airdresser/r.html?bn=1&source=dotcom"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:e-catalogue:airdresser">
                                          <span className="gnb__depth3-link-text">
                                            AirDresser
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/microwaveovens/r.html?source=dotcom&showcon=0&bn=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:e-catalogue:microwave ovens">
                                          <span className="gnb__depth3-link-text">
                                            Microwave Ovens
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="//www.samsungindiamarketing.com/Promotions/catalogues/dishwasher/?showcon=0&bn=1&source=Dotcom#p=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:e-catalogue:dishwashers">
                                          <span className="gnb__depth3-link-text">
                                            Dishwashers
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/airsolution/r.html?source=dotcom&showcon=0&bn=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:e-catalogue:air conditioners | air purifiers">
                                          <span className="gnb__depth3-link-text">
                                            Air Conditioners | Air Purifiers
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/vacuumcleaner/r.html?source=Dotcom&bn=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="home appliances:e-catalogue:vaccum cleaners">
                                          <span className="gnb__depth3-link-text">
                                            Vaccum Cleaners
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>


                            </ul>
                            <div className="gnb__feature-container">
                              <a className="gnb__feature-container-link"
                                href="https://www.samsung.com/in/vacuum-cleaners/all-vacuum-cleaners/"
                                an-tr="nv00_gnb--cta-feature" an-ca="navigation" an-ac="gnb"
                                an-la="feature image:home appliances:jet™ vacuum cleaner:buy now">
                                <div className="image">
                                  <img className="image__preview responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/11752_Vacuum_Cleaner_Banner_624x624_02.jpg?$LazyLoad_Home_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/11752_Vacuum_Cleaner_Banner_624x624_02.jpg?$LazyLoad_Home_JPG$"
                                    alt="Jet™ Vacuum Cleaner"
                                    src="https://images.samsung.com/is/image/samsung/assets/in/gnb/11752_Vacuum_Cleaner_Banner_624x624_02.jpg" />
                                  <img className="image__main responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/11752_Vacuum_Cleaner_Banner_624x624_02.jpg?$330_330_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/11752_Vacuum_Cleaner_Banner_624x624_02.jpg?$624_624_JPG$"
                                    alt="Jet™ Vacuum Cleaner" src="https://images.samsung.com/is/image/samsung/assets/in/gnb/11752_Vacuum_Cleaner_Banner_624x624_02.jpg" />
                                </div>
                                <div className="gnb__feature-container-contents">
                                  <p className="gnb__feature-container-description">Jet™
                                    Vacuum Cleaner</p>
                                  <span className="cta cta--underline cta--black">Buy
                                    now</span>
                                </div>
                              </a>

                            </div>
                            <a className="gnb__depth2-close" href="#" onClick={e => e.preventDefault()} role="button"
                              an-tr="nv00_gnb--image-action" an-ca="navigation" an-ac="gnb"
                              an-la="gnb:close">
                              <span className="hidden">Close Menu</span>
                              <svg className="icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z">
                                </path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </li>

                      <li className="gnb__depth1-menu has-depth-menu" role="presentation">
                        <a className="gnb__depth1-link" href="#" onClick={e => e.preventDefault()} role="menuitem"
                          data-engname="laptop and monitors" aria-expanded="false"
                          aria-haspopup="true">
                          <span className="gnb__depth1-link-text">Laptop &amp; Monitors</span>
                          <svg className="icon icon--next" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 96 96" focusable="false">
                            <path
                              d="M35.757 84.389l-5.533-5.778 31.982-30.612L30.224 17.39l5.533-5.779 38.018 36.388z">
                            </path>
                          </svg>
                        </a>
                        <div className="gnb__depth2-wrap">
                          <div className="gnb__depth-back-wrap">
                            <a className="gnb__depth-back" href="#" onClick={e => e.preventDefault()}>
                              <svg className="icon icon--back" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M40.544 11.613l5.538 5.774L18.335 44l75.054.001v8H18.337l27.745 26.612-5.538 5.774L2.611 48l37.933-36.387z">
                                </path>
                              </svg>
                              <span className="hidden">Back to 1 Depth Menu</span>
                            </a>
                          </div>
                          <div className="gnb__depth2-inner" aria-hidden="true">
                            <div className="gnb__depth2-title-wrap">
                              <strong className="gnb__depth2-title">

                                <span className="gnb__depth2-title-text">Laptop &amp;
                                  Monitors</span>


                              </strong>
                            </div>
                            <ul className="gnb__depth2" role="menu">

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="laptop and monitors:new and featured"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    New &amp; Featured

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/?galaxy-book2-pro-360"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:new and featured:galaxy book2 pro 360">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Book2 Pro 360

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/?galaxy-book2-pro"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:new and featured:galaxy book2 pro">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Book2 Pro

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/?galaxy-book2-360"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:new and featured:galaxy book2 360">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Book2 360

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/?galaxy-book2"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:new and featured:galaxy book2">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Book2

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/?galaxy-book-go"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:new and featured:galaxy book go">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Book Go

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/smart/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:new and featured:smart monitors">
                                          <span className="gnb__depth3-link-text">
                                            Smart Monitors

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/curved/?ultra-wqhd-3440x1440"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:new and featured:ultra wide curved monitor">
                                          <span className="gnb__depth3-link-text">
                                            Ultra Wide Curved Monitor

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/gaming/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:new and featured:gaming monitor">
                                          <span className="gnb__depth3-link-text">
                                            Gaming Monitor

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/curved/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:new and featured:curved monitor">
                                          <span className="gnb__depth3-link-text">
                                            Curved Monitor

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="laptop and monitors:galaxy book"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Galaxy Book

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/galaxy-book/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:galaxy book:discover galaxy book">
                                          <span className="gnb__depth3-link-text">
                                            Discover Galaxy Book

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/?galaxy-book2-pro-360"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:galaxy book:galaxy book2 pro 360">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Book2 Pro 360

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/?galaxy-book2-pro"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:galaxy book:galaxy book2 pro">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Book2 Pro

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/?galaxy-book2-360"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:galaxy book:galaxy book2 360">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Book2 360

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/?galaxy-book2"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:galaxy book:galaxy book2">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Book2

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/?galaxy-book-go"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:galaxy book:galaxy book go">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Book Go

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/windows-11/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:galaxy book:windows 11">
                                          <span className="gnb__depth3-link-text">
                                            Windows 11

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computer-accessories/all-computer-accessories/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:galaxy book:accessories">
                                          <span className="gnb__depth3-link-text">
                                            Accessories

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/all-computers/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:galaxy book:all galaxy book">
                                          <span className="gnb__depth3-link-text">
                                            All Galaxy Book

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="laptop and monitors:monitors"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Monitors

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:monitors:discover monitors">
                                          <span className="gnb__depth3-link-text">
                                            Discover Monitors

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/smart/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:monitors:smart monitor">
                                          <span className="gnb__depth3-link-text">
                                            Smart Monitor

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/gaming/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:monitors:gaming monitor">
                                          <span className="gnb__depth3-link-text">
                                            Gaming Monitor

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/high-resolution/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:monitors:high resolution monitors">
                                          <span className="gnb__depth3-link-text">
                                            High Resolution Monitor

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/curved/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:monitors:curved monitor">
                                          <span className="gnb__depth3-link-text">
                                            Curved Monitor

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/flat/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:monitors:flat monitor">
                                          <span className="gnb__depth3-link-text">
                                            Flat Monitor

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/business/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:monitors:business monitors">
                                          <span className="gnb__depth3-link-text">
                                            Business Monitor

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/all-monitors/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:monitors:all monitors">
                                          <span className="gnb__depth3-link-text">
                                            All Monitors

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation"
                                data-type-code="19040000" data-group-code="19000000">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="laptop and monitors:memory and storage"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Memory &amp; Storage

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/memory-storage/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:memory and storage:discover memory and storage">
                                          <span className="gnb__depth3-link-text">
                                            Discover Memory &amp; Storage

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/memory-storage/nvme-ssd/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:memory and storage:nvme ssd">
                                          <span className="gnb__depth3-link-text">
                                            NVMe SSD

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/memory-storage/sata-ssd/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:memory and storage:sata ssd">
                                          <span className="gnb__depth3-link-text">
                                            SATA SSD

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/memory-storage/portable-ssd/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:memory and storage:portable ssd">
                                          <span className="gnb__depth3-link-text">
                                            Portable SSD

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/memory-storage/memory-card/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:memory and storage:memory cards">
                                          <span className="gnb__depth3-link-text">
                                            Memory Cards

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/memory-storage/usb-flash-drive/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:memory and storage:usb flash drive">
                                          <span className="gnb__depth3-link-text">
                                            USB Flash Drive

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/memory-storage/all-memory-storage/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:memory and storage:all memory and storage">
                                          <span className="gnb__depth3-link-text">
                                            All Memory &amp; Storage

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="laptop and monitors:e-catalogue"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    e-catalogue


                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="//www.samsungindiamarketing.com/Promotions/catalogues/laptop/r.html?showcon=0&bn=1&source=Dotcom"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:e-catalogue:laptops">
                                          <span className="gnb__depth3-link-text">
                                            Laptops
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsungindiamarketing.com/Promotions/catalogues/monitor/?showcon=null&bn=1&source=dotcom#p=1"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="laptop and monitors:e-catalogue:monitors">
                                          <span className="gnb__depth3-link-text">
                                            Monitors
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>


                            </ul>
                            <div className="gnb__feature-container">
                              <a className="gnb__feature-container-link"
                                href="https://www.samsung.com/in/computers/galaxy-book/galaxy-book2-pro-360-15inch-i7-16gb-512gb-np950qed-kh1in/buy/"
                                an-tr="nv00_gnb--cta-feature" an-ca="navigation" an-ac="gnb"
                                an-la="feature image:laptop and monitors:now in burgundy :buy now">
                                <div className="image">
                                  <img className="image__preview responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/12849_GB2-Pro-360-Burgundy-Banner_624x624.jpg?$LazyLoad_Home_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/12849_GB2-Pro-360-Burgundy-Banner_624x624.jpg?$LazyLoad_Home_JPG$"
                                    alt="Now in Burgundy " src="https://images.samsung.com/is/image/samsung/assets/in/12849_GB2-Pro-360-Burgundy-Banner_624x624.jpg" />
                                  <img className="image__main responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/12849_GB2-Pro-360-Burgundy-Banner_624x624.jpg?$330_330_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/12849_GB2-Pro-360-Burgundy-Banner_624x624.jpg?$624_624_JPG$"
                                    alt="Now in Burgundy " src="https://images.samsung.com/is/image/samsung/assets/in/12849_GB2-Pro-360-Burgundy-Banner_624x624.jpg" />
                                </div>
                                <div className="gnb__feature-container-contents">
                                  <p className="gnb__feature-container-description">Now in
                                    Burgundy </p>
                                  <span className="cta cta--underline cta--black">Buy
                                    now</span>
                                </div>
                              </a>

                            </div>
                            <a className="gnb__depth2-close" href="#" onClick={e => e.preventDefault()} role="button"
                              an-tr="nv00_gnb--image-action" an-ca="navigation" an-ac="gnb"
                              an-la="gnb:close">
                              <span className="hidden">Close Menu</span>
                              <svg className="icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z">
                                </path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </li>

                      <li className="gnb__depth1-menu has-depth-menu" role="presentation">
                        <a className="gnb__depth1-link" href="#" onClick={e => e.preventDefault()} role="menuitem"
                          data-engname="displays" aria-expanded="false" aria-haspopup="true">
                          <span className="gnb__depth1-link-text">Displays</span>
                          <svg className="icon icon--next" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 96 96" focusable="false">
                            <path
                              d="M35.757 84.389l-5.533-5.778 31.982-30.612L30.224 17.39l5.533-5.779 38.018 36.388z">
                            </path>
                          </svg>
                        </a>
                        <div className="gnb__depth2-wrap">
                          <div className="gnb__depth-back-wrap">
                            <a className="gnb__depth-back" href="#" onClick={e => e.preventDefault()}>
                              <svg className="icon icon--back" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M40.544 11.613l5.538 5.774L18.335 44l75.054.001v8H18.337l27.745 26.612-5.538 5.774L2.611 48l37.933-36.387z">
                                </path>
                              </svg>
                              <span className="hidden">Back to 1 Depth Menu</span>
                            </a>
                          </div>
                          <div className="gnb__depth2-inner" aria-hidden="true">
                            <div className="gnb__depth2-title-wrap">
                              <strong className="gnb__depth2-title">

                                <span className="gnb__depth2-title-text">Displays</span>


                              </strong>
                            </div>
                            <ul className="gnb__depth2" role="menu">

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="displays:new and featured"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    New &amp; Featured

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/business/displays/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:new and featured:business display solution">
                                          <span className="gnb__depth3-link-text">
                                            Business Display Solution

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="displays:monitors"
                                  aria-expanded="false" aria-haspopup="true">

                                  <span className="gnb__depth2-link-text">
                                    Monitors

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:monitors:discover monitors">
                                          <span className="gnb__depth3-link-text">
                                            Discover Monitors

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/all-monitors/?curved+uhd+gaming+01i05"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:monitors:home">
                                          <span className="gnb__depth3-link-text">
                                            Home

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/business/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:monitors:business">
                                          <span className="gnb__depth3-link-text">
                                            For Business

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/monitors/all-monitors/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:monitors:all monitors">
                                          <span className="gnb__depth3-link-text">
                                            All Monitors

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="displays:smart signage"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Smart Signage

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smart-signage/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:smart signage:discover smart signage">
                                          <span className="gnb__depth3-link-text">
                                            Discover Smart Signage

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smart-signage/digital-flipchart/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:smart signage:digital flipchart">
                                          <span className="gnb__depth3-link-text">
                                            Digital Flipchart

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smart-signage/qled-8k-signage/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:smart signage:qled 8k">
                                          <span className="gnb__depth3-link-text">
                                            QLED 8K

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smart-signage/uhd-4k-signage/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:smart signage:crystal uhd">
                                          <span className="gnb__depth3-link-text">
                                            Crystal UHD

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smart-signage/outdoor-signage/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:smart signage:outdoor and window">
                                          <span className="gnb__depth3-link-text">
                                            Outdoor &amp; Window

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smart-signage/all-smart-signage/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:smart signage:all smart signage">
                                          <span className="gnb__depth3-link-text">
                                            All Smart Signage

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="displays:led signage"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    LED Signage

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/the-wall/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="displays:led signage:the wall">
                                          <span className="gnb__depth3-link-text">
                                            The Wall

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>


                            </ul>
                            <div className="gnb__feature-container">
                              <a className="gnb__feature-container-link"
                                href="https://www.samsung.com/in/smart-signage/digital-flipchart/wm55r-flip2-0-55-inch-lh55wmrwbgcxxl/"
                                an-tr="nv00_gnb--cta-feature" an-ca="navigation" an-ac="gnb"
                                an-la="feature image:displays: :buy now">
                                <div className="image">
                                  <img className="image__preview responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/624x624_GNB.jpg?$LazyLoad_Home_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/624x624_GNB.jpg?$LazyLoad_Home_JPG$" src="https://images.samsung.com/is/image/samsung/assets/in/gnb/624x624_GNB.jpg" />
                                  <img className="image__main responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/624x624_GNB.jpg?$330_330_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/624x624_GNB.jpg?$624_624_JPG$" src="https://images.samsung.com/is/image/samsung/assets/in/gnb/624x624_GNB.jpg" />
                                </div>
                                <div className="gnb__feature-container-contents">
                                  <p className="gnb__feature-container-description"> </p>
                                  <span className="cta cta--underline cta--black">Buy
                                    now</span>
                                </div>
                              </a>

                            </div>
                            <a className="gnb__depth2-close" href="#" onClick={e => e.preventDefault()} role="button"
                              an-tr="nv00_gnb--image-action" an-ca="navigation" an-ac="gnb"
                              an-la="gnb:close">
                              <span className="hidden">Close Menu</span>
                              <svg className="icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z">
                                </path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </li>


                      <li className="gnb__depth1-menu" role="presentation">
                        <a className="gnb__depth1-link" href="https://www.samsung.com/in/accessories/"
                          role="menuitem" an-tr="nv00_gnb--click-depth1" an-ca="navigation"
                          an-ac="gnb" an-la="accessories"><span
                            className="gnb__depth1-link-text">Accessories</span></a>

                      </li>






                      <li className="gnb__depth1-menu has-depth-menu" role="presentation">
                        <a className="gnb__depth1-link" href="#" onClick={e => e.preventDefault()} role="menuitem"
                          data-engname="smartthings" aria-expanded="false" aria-haspopup="true">
                          <span className="gnb__depth1-link-text">SmartThings</span>
                          <svg className="icon icon--next" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 96 96" focusable="false">
                            <path
                              d="M35.757 84.389l-5.533-5.778 31.982-30.612L30.224 17.39l5.533-5.779 38.018 36.388z">
                            </path>
                          </svg>
                        </a>
                        <div className="gnb__depth2-wrap">
                          <div className="gnb__depth-back-wrap">
                            <a className="gnb__depth-back" href="#" onClick={e => e.preventDefault()}>
                              <svg className="icon icon--back" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M40.544 11.613l5.538 5.774L18.335 44l75.054.001v8H18.337l27.745 26.612-5.538 5.774L2.611 48l37.933-36.387z">
                                </path>
                              </svg>
                              <span className="hidden">Back to 1 Depth Menu</span>
                            </a>
                          </div>
                          <div className="gnb__depth2-inner" aria-hidden="true">
                            <div className="gnb__depth2-title-wrap">
                              <strong className="gnb__depth2-title">


                                <a className="gnb__depth2-title-link"
                                  href="https://www.samsung.com/in/smartthings/do-the-smartthings/"
                                  an-tr="nv00_gnb--click-depth1" an-ca="navigation"
                                  an-ac="gnb"
                                  an-la="smartthings:smartthings">SmartThings</a>


                              </strong>
                            </div>
                            <ul className="gnb__depth2" role="menu">



                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/smartthings/work-from-home/"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="smartthings:work from home"
                                  aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Work from Home

                                  </span>
                                </a>

                              </li>

                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/smartthings/set-the-mood/"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="smartthings:set the mood" aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Set the Mood

                                  </span>
                                </a>

                              </li>

                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/smartthings/think-green-at-home/"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="smartthings:think green at home"
                                  aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Think Green at Home

                                  </span>
                                </a>

                              </li>

                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/smartthings/stay-fit-and-healthy/"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="smartthings:stay fit and healthy"
                                  aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Stay Fit &amp; Healthy

                                  </span>
                                </a>

                              </li>


                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="smartthings:apps and products"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Apps &amp; Products

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/apps/smartthings/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="smartthings:apps and products:smartthings app">
                                          <span className="gnb__depth3-link-text">
                                            SmartThings App

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>


                            </ul>
                            <div className="gnb__feature-container">
                              <a className="gnb__feature-container-link"
                                href="https://www.samsung.com/in/smartthings/do-the-smartthings/"
                                an-tr="nv00_gnb--cta-feature" an-ca="navigation" an-ac="gnb"
                                an-la="feature image:smartthings:do the smartthings!:learn more">
                                <div className="image">
                                  <img className="image__preview responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/smartthings/cx-mde0004_dts_gnb-feature_pc_mo_624x624.jpg?$LazyLoad_Home_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/smartthings/cx-mde0004_dts_gnb-feature_pc_mo_624x624.jpg?$LazyLoad_Home_JPG$"
                                    alt="SmartThings" src="https://images.samsung.com/is/image/samsung/assets/in/smartthings/cx-mde0004_dts_gnb-feature_pc_mo_624x624.jpg" />
                                  <img className="image__main responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/smartthings/cx-mde0004_dts_gnb-feature_pc_mo_624x624.jpg?$330_330_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/smartthings/cx-mde0004_dts_gnb-feature_pc_mo_624x624.jpg?$624_624_JPG$"
                                    alt="SmartThings" src="https://images.samsung.com/is/image/samsung/assets/in/smartthings/cx-mde0004_dts_gnb-feature_pc_mo_624x624.jpg" />
                                </div>
                                <div className="gnb__feature-container-contents">
                                  <p className="gnb__feature-container-description">Do the
                                    SmartThings!</p>
                                  <span className="cta cta--underline cta--black">Learn
                                    more</span>
                                </div>
                              </a>

                            </div>
                            <a className="gnb__depth2-close" href="#" onClick={e => e.preventDefault()} role="button"
                              an-tr="nv00_gnb--image-action" an-ca="navigation" an-ac="gnb"
                              an-la="gnb:close">
                              <span className="hidden">Close Menu</span>
                              <svg className="icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z">
                                </path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </li>

                      <li className="gnb__depth1-menu has-depth-menu" role="presentation">
                        <a className="gnb__depth1-link" href="#" onClick={e => e.preventDefault()} role="menuitem"
                          data-engname="offers" aria-expanded="false" aria-haspopup="true">
                          <span className="gnb__depth1-link-text">Offers</span>
                          <svg className="icon icon--next" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 96 96" focusable="false">
                            <path
                              d="M35.757 84.389l-5.533-5.778 31.982-30.612L30.224 17.39l5.533-5.779 38.018 36.388z">
                            </path>
                          </svg>
                        </a>
                        <div className="gnb__depth2-wrap">
                          <div className="gnb__depth-back-wrap">
                            <a className="gnb__depth-back" href="#" onClick={e => e.preventDefault()}>
                              <svg className="icon icon--back" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M40.544 11.613l5.538 5.774L18.335 44l75.054.001v8H18.337l27.745 26.612-5.538 5.774L2.611 48l37.933-36.387z">
                                </path>
                              </svg>
                              <span className="hidden">Back to 1 Depth Menu</span>
                            </a>
                          </div>
                          <div className="gnb__depth2-inner" aria-hidden="true">
                            <div className="gnb__depth2-title-wrap">
                              <strong className="gnb__depth2-title">


                                <a className="gnb__depth2-title-link"
                                  href="https://www.samsung.com/in/shop/"
                                  an-tr="nv00_gnb--click-depth1" an-ca="navigation"
                                  an-ac="gnb" an-la="offers:offers">Offers</a>


                              </strong>
                            </div>
                            <ul className="gnb__depth2" role="menu">

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="offers:view all offers"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    View All offers

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/offer/online/samsung-fest/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:view all offers:offers">
                                          <span className="gnb__depth3-link-text">
                                            Offers

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microsite/smart-club/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:view all offers:smart club loyalty program">
                                          <span className="gnb__depth3-link-text">
                                            Smart Club Loyalty Program

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/offer/exchange/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:view all offers:samsung exchange program">
                                          <span className="gnb__depth3-link-text">
                                            Samsung Exchange Program

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/offer/online/finance-plus/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:view all offers:samsung finance plus">
                                          <span className="gnb__depth3-link-text">
                                            Samsung Finance+

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="offers:smart ways to buy"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Smart Ways to Buy

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/store/corporate/"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:smart ways to buy:corporate employee program">
                                          <span className="gnb__depth3-link-text">
                                            Corporate Employee Program
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microsite/student-advantage/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:smart ways to buy:samsung student advantage">
                                          <span className="gnb__depth3-link-text">
                                            Samsung Student Advantage

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microsite/shop-referral/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:smart ways to buy:samsung referral advantage">
                                          <span className="gnb__depth3-link-text">
                                            Samsung Referral Advantage

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microsite/defence-purchase-program/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:smart ways to buy:defence purchase program">
                                          <span className="gnb__depth3-link-text">
                                            Defence Purchase Program

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/offer/online/combo-offer/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:smart ways to buy:buy more save more">
                                          <span className="gnb__depth3-link-text">
                                            Buy More, Save More

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>






                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/live-offers/"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="offers:samsung live" aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Samsung Live

                                  </span>
                                </a>

                              </li>


                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="offers:shop mobile"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Shop Mobile

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/shop/mobile/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:view all mobiles">
                                          <span className="gnb__depth3-link-text">
                                            View All Mobiles

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/mobiles-by-price/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:mobiles by price">
                                          <span className="gnb__depth3-link-text">
                                            Mobiles by Price

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/mobiles-by-battery-life/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:mobiles by battery capacity">
                                          <span className="gnb__depth3-link-text">
                                            Mobiles by Battery Capacity

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/mobiles-by-memory-storage/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:mobiles by memory storage">
                                          <span className="gnb__depth3-link-text">
                                            Mobiles by Memory Storage

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/mobiles-by-networks/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:mobiles by mobile networks">
                                          <span className="gnb__depth3-link-text">
                                            Mobiles by Mobile Networks

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/mobiles-by-camera/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:mobiles by camera">
                                          <span className="gnb__depth3-link-text">
                                            Mobiles by Camera

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/mobiles-by-ram-size/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:mobiles by ram size">
                                          <span className="gnb__depth3-link-text">
                                            Mobiles by RAM Size

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/mobiles-by-display/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:mobiles by display">
                                          <span className="gnb__depth3-link-text">
                                            Mobiles by Display

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/mobiles-by-screen-size/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:mobiles by screen size">
                                          <span className="gnb__depth3-link-text">
                                            Mobiles by Screen Size

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/gaming-phone/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:gaming phones">
                                          <span className="gnb__depth3-link-text">
                                            Gaming Phones

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/smartphones/water-resistant-phones/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop mobile:water resistant mobiles">
                                          <span className="gnb__depth3-link-text">
                                            Water Resistant Mobiles

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="offers:shop home appliances"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Shop Home Appliances

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/fridge-by-price/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop home appliances:shop refrigerator by price">
                                          <span className="gnb__depth3-link-text">
                                            Shop Refrigerator By Price

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/fridge-by-capacity/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop home appliances:shop refrigerator by capacity">
                                          <span className="gnb__depth3-link-text">
                                            Shop Refrigerator By Capacity

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/refrigerators/fridge-by-star-rating/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop home appliances:shop refrigerator by star rating">
                                          <span className="gnb__depth3-link-text">
                                            Shop Refrigerator By Star Rating

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/washing-machines-by-price/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop home appliances:shop washing machine by price">
                                          <span className="gnb__depth3-link-text">
                                            Shop Washing Machine By Price

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/washing-machines-by-capacity/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop home appliances:shop washing machine by capacity">
                                          <span className="gnb__depth3-link-text">
                                            Shop Washing Machine By Capacity

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/washers-and-dryers/washing-machines-by-type/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop home appliances:shop washing machine by type">
                                          <span className="gnb__depth3-link-text">
                                            Shop Washing Machine By Type

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microwave-ovens/microwave-ovens-by-type/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop home appliances:shop microwave oven by type">
                                          <span className="gnb__depth3-link-text">
                                            Shop Microwave Oven By Type

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microwave-ovens/all-microwave-ovens/?available-to-order"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop home appliances:shop microwave oven">
                                          <span className="gnb__depth3-link-text">
                                            Shop Microwave Oven

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/air-conditioners/air-conditioners-by-capacity/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop home appliances:shop air conditioner">
                                          <span className="gnb__depth3-link-text">
                                            Shop Air Conditioner

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/dishwashers/all-dishwashers/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop home appliances:shop dishwashers">
                                          <span className="gnb__depth3-link-text">
                                            Shop Dishwashers

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="offers:shop tablets"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Shop Tablets

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tablets/tablets-by-price/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop tablets:shop tablets by price">
                                          <span className="gnb__depth3-link-text">
                                            Shop Tablets by Price

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="offers:shop television"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Shop Television

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/all-tvs/?available-to-order"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop television:overview">
                                          <span className="gnb__depth3-link-text">
                                            Overview

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/television-by-size/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop television:television by size">
                                          <span className="gnb__depth3-link-text">
                                            Television by Size

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/television-by-features/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop television:television by features">
                                          <span className="gnb__depth3-link-text">
                                            Television by Features

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/tvs/television-by-price/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop television:television by price">
                                          <span className="gnb__depth3-link-text">
                                            Television by Price

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="offers:shop wearables"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Shop Wearables

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/watches/smartwatch/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop wearables:shop galaxy smart watches">
                                          <span className="gnb__depth3-link-text">
                                            Shop Galaxy Smart Watches

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/watches/smartwatches-by-price/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop wearables:shop smartwatches by price">
                                          <span className="gnb__depth3-link-text">
                                            Shop Smartwatches By Price

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-sound/earbuds/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop wearables:shop galaxy earbuds">
                                          <span className="gnb__depth3-link-text">
                                            Shop Galaxy Earbuds

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/audio-sound/headphones/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop wearables:shop earphones">
                                          <span className="gnb__depth3-link-text">
                                            Shop Earphones

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="offers:shop monitors and laptops"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Shop Monitors &amp; Laptops

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/offer/online/samsung-fest/?deal=monitors"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop monitors and laptops:shop monitors">
                                          <span className="gnb__depth3-link-text">
                                            Shop Monitors

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/computers/laptops/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="offers:shop monitors and laptops:shop laptops">
                                          <span className="gnb__depth3-link-text">
                                            Shop Laptops

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>






                              <li className="gnb__depth2-menu" role="presentation">
                                <a className="gnb__depth2-link"
                                  href="https://www.samsung.com/in/mobile-accessories/all-mobile-accessories/?exclude-out-of-stock"
                                  role="menuitem" an-tr="nv00_gnb--click-depth2"
                                  an-ca="navigation" an-ac="gnb"
                                  an-la="offers:shop accessories" aria-expanded="false">
                                  <span className="gnb__depth2-link-text">
                                    Shop Accessories

                                  </span>
                                </a>

                              </li>
                            </ul>
                            <div className="gnb__feature-container">
                              <a className="gnb__feature-container-link"
                                href="https://www.samsung.com/in/offer/online/samsung-fest/"
                                an-tr="nv00_gnb--cta-feature" an-ca="navigation" an-ac="gnb"
                                an-la="feature image:offers:benefits up to ₹ 24500*:buy now">
                                <div className="image">
                                  <img className="image__preview responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/home/624x624.jpg?$LazyLoad_Home_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/home/624x624.jpg?$LazyLoad_Home_JPG$"
                                    alt="Benefits up to ₹ 24500*" src="https://images.samsung.com/is/image/samsung/assets/in/home/624x624.jpg" />
                                  <img className="image__main responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/home/624x624.jpg?$330_330_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/home/624x624.jpg?$624_624_JPG$"
                                    alt="Benefits up to ₹ 24500*" src="https://images.samsung.com/is/image/samsung/assets/in/home/624x624.jpg" />
                                </div>
                                <div className="gnb__feature-container-contents">
                                  <p className="gnb__feature-container-description">Benefits
                                    up to ₹ 24500*</p>
                                  <span className="cta cta--underline cta--black">Buy
                                    now</span>
                                </div>
                              </a>

                            </div>
                            <a className="gnb__depth2-close" href="#" onClick={e => e.preventDefault()} role="button"
                              an-tr="nv00_gnb--image-action" an-ca="navigation" an-ac="gnb"
                              an-la="gnb:close">
                              <span className="hidden">Close Menu</span>
                              <svg className="icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z">
                                </path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </li>

                    </ul>

                  </div>
                  <div className="gnb__sub">

                    <ul className="gnb__depth1" role="menubar">



                      <li className="gnb__depth1-menu has-depth-menu" role="presentation">
                        <a className="gnb__depth1-link" href="#" onClick={e => e.preventDefault()} role="menuitem"
                          data-engname="support" aria-expanded="false" aria-haspopup="true">
                          <span className="gnb__depth1-link-text">Support</span>
                          <svg className="icon icon--next" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 96 96" focusable="false">
                            <path
                              d="M35.757 84.389l-5.533-5.778 31.982-30.612L30.224 17.39l5.533-5.779 38.018 36.388z">
                            </path>
                          </svg>
                        </a>
                        <div className="gnb__depth2-wrap">
                          <div className="gnb__depth-back-wrap">
                            <a className="gnb__depth-back" href="#" onClick={e => e.preventDefault()}>
                              <svg className="icon icon--back" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M40.544 11.613l5.538 5.774L18.335 44l75.054.001v8H18.337l27.745 26.612-5.538 5.774L2.611 48l37.933-36.387z">
                                </path>
                              </svg>
                              <span className="hidden">Back to 1 Depth Menu</span>
                            </a>
                          </div>
                          <div className="gnb__depth2-inner" aria-hidden="true">
                            <div className="gnb__depth2-title-wrap">
                              <strong className="gnb__depth2-title">


                                <a className="gnb__depth2-title-link"
                                  href="https://www.samsung.com/in/support/"
                                  an-tr="nv00_gnb--click-depth1" an-ca="navigation"
                                  an-ac="gnb" an-la="support:support">Support</a>


                              </strong>
                            </div>
                            <ul className="gnb__depth2" role="menu">

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="support:product help and tips"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Product help &amp; Tips

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/#productsupport"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:product help and tips:faqs">
                                          <span className="gnb__depth3-link-text">
                                            FAQs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/#productsupport"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:product help and tips:manual and software&#39;s">
                                          <span className="gnb__depth3-link-text">
                                            Manual &amp; Software's

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="//www.samsung.com/in/apps/smart-switch/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:product help and tips:smart switch">
                                          <span className="gnb__depth3-link-text">
                                            Smart Switch

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/newsalert/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:product help and tips:news and alerts">
                                          <span className="gnb__depth3-link-text">
                                            News &amp; Alerts

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://r2.community.samsung.com/t5/India/ct-p/in"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:product help and tips:ask community">
                                          <span className="gnb__depth3-link-text">
                                            Ask Community
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="support:warranty"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Warranty

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/warranty/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:warranty:warranty policy and info">
                                          <span className="gnb__depth3-link-text">
                                            Warranty Policy &amp; Info

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/out-of-warranty-repair-charges/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:warranty:out-of-warranty repair charges">
                                          <span className="gnb__depth3-link-text">
                                            Out-of-warranty Repair Charges

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/spare-part-pricing-list-for-repair/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:warranty:phone spare part cost">
                                          <span className="gnb__depth3-link-text">
                                            Phone spare part cost

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/samsung-galaxy-smart-phone-display-repair/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:warranty:galaxy screen replacement">
                                          <span className="gnb__depth3-link-text">
                                            Galaxy Screen Replacement

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="support:repair service"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Repair Service

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/service-center/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:repair service:service center locator">
                                          <span className="gnb__depth3-link-text">
                                            Service center locator

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="//www.samsung.com/in/support/your-service/main/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:repair service:request service">
                                          <span className="gnb__depth3-link-text">
                                            Request service

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="//www.samsung.com/in/support/your-service/track-repair/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:repair service:track my service request">
                                          <span className="gnb__depth3-link-text">
                                            Track my service request

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung-appointment.com/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:repair service:book an appointment">
                                          <span className="gnb__depth3-link-text">
                                            Book an appointment

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem" data-engname="support:contact us"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Contact Us

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://wa.me/91180057267864?text=hi"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:contact us:whatsapp us">
                                          <span className="gnb__depth3-link-text">
                                            WhatsApp Us (हिंदी/ English)
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/email/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:contact us:email">
                                          <span className="gnb__depth3-link-text">
                                            Email

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/email-the-ceo/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:contact us:email the ceo">
                                          <span className="gnb__depth3-link-text">
                                            Email the CEO

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://wa.me/91180057267864?text=hi"
                                          role="menuitem" target="_blank"
                                          aria-label="Open in a New Window"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:contact us:sign language support">
                                          <span className="gnb__depth3-link-text">
                                            Sign language support
                                            <svg className="icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 96 96"
                                              focusable="false">
                                              <path
                                                d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z">
                                              </path>
                                            </svg>

                                          </span>
                                        </a>

                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/support/#contact/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:contact us:call us">
                                          <span className="gnb__depth3-link-text">
                                            Call Us

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/microsite/care-for-clean-india/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:contact us:care for clean india">
                                          <span className="gnb__depth3-link-text">
                                            Care for clean India

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li className="gnb__depth2-menu has-depth-menu" role="presentation">
                                <a className="gnb__depth2-link" href="#" onClick={e => e.preventDefault()}
                                  role="menuitem"
                                  data-engname="support:online shop support"
                                  aria-expanded="false" aria-haspopup="true">
                                  <span className="gnb__depth2-link-text">
                                    Online Shop Support

                                  </span>
                                  <svg className="icon icon--next"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M31.828 16.306l3.457-3.612L72.172 48 35.285 83.306l-3.457-3.612L64.941 48z">
                                    </path>
                                  </svg>
                                  <svg className="icon icon--dropdown"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 96 96" focusable="false">
                                    <path
                                      d="M48 73.254L11.651 36.361l5.698-5.614L48 61.855l30.651-31.108 5.698 5.614z">
                                    </path>
                                  </svg>
                                </a>
                                <div className="gnb__depth3-wrap">
                                  <div className="gnb__depth3-inner">
                                    <ul className="gnb__depth3" role="menu">
                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/shop-faq/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:online shop support:shop faqs">
                                          <span className="gnb__depth3-link-text">
                                            Shop FAQs

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/web/search-orders/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:online shop support:track order status">
                                          <span className="gnb__depth3-link-text">
                                            Track Order Status

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/shop-faq/products-and-orders/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:online shop support:order information">
                                          <span className="gnb__depth3-link-text">
                                            Order Information

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/shop-faq/payment-and-financing/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:online shop support:payment information">
                                          <span className="gnb__depth3-link-text">
                                            Payment Information

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/shop-faq/delivery-and-installations/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:online shop support:shipping">
                                          <span className="gnb__depth3-link-text">
                                            Shipping

                                          </span>
                                        </a>
                                      </li>

                                      <li className="gnb__depth3-menu"
                                        role="presentation">
                                        <a className="gnb__depth3-link"
                                          href="https://www.samsung.com/in/shop-faq/returns-and-cancellations/"
                                          role="menuitem"
                                          an-tr="nv00_gnb--text-depth3"
                                          an-ca="navigation" an-ac="gnb"
                                          an-la="support:online shop support:cancellation and return policy">
                                          <span className="gnb__depth3-link-text">
                                            Cancellation &amp; Return Policy

                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>


                            </ul>
                            <div className="gnb__feature-container">
                              <a className="gnb__feature-container-link"
                                href="https://samsungdigitalservicecenter.com/"
                                an-tr="nv00_gnb--cta-feature" an-ca="navigation" an-ac="gnb"
                                an-la="feature image:support:introducing digital service center:click here">
                                <div className="image">
                                  <img className="image__preview responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/12617_DSC_02_624x624.png?$LazyLoad_Home_PNG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/12617_DSC_02_624x624.png?$LazyLoad_Home_PNG$"
                                    alt=" Introducing Digital Service Center" src="https://images.samsung.com/is/image/samsung/assets/in/gnb/12617_DSC_02_624x624.png" />
                                  <img className="image__main responsive-img "
                                    data-desktop-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/12617_DSC_02_624x624.png?$330_330_JPG$"
                                    data-mobile-src="https://images.samsung.com/is/image/samsung/assets/in/gnb/12617_DSC_02_624x624.png?$624_624_JPG$"
                                    alt=" Introducing Digital Service Center" src="https://images.samsung.com/is/image/samsung/assets/in/gnb/12617_DSC_02_624x624.png" />
                                </div>
                                <div className="gnb__feature-container-contents">
                                  <p className="gnb__feature-container-description"> </p>
                                  <span className="cta cta--underline cta--black">Click
                                    Here</span>
                                </div>
                              </a>

                            </div>
                            <a className="gnb__depth2-close" href="#" onClick={e => e.preventDefault()} role="button"
                              an-tr="nv00_gnb--image-action" an-ca="navigation" an-ac="gnb"
                              an-la="gnb:close">
                              <span className="hidden">Close Menu</span>
                              <svg className="icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 96 96" focusable="false">
                                <path
                                  d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z">
                                </path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </li>

                      <li className="gnb__depth1-menu" role="presentation">
                        <a className="gnb__depth1-link" href="https://www.samsung.com/in/business/"
                          role="menuitem" an-tr="nv00_gnb--click-depth1" an-ca="navigation"
                          an-ac="gnb" an-la="for business"><span className="gnb__depth1-link-text">For
                            Business</span></a>
                      </li>

                    </ul>


                    <ul className="gnb__utility">
                      {props.isLoggedIn && 
                      <li>
                        <Notification {...props}/>
                      </li>}
                      <li className="gnb__cart">
                        <a href="https://www.samsung.com/in/web/cart/"
                          className="gnb__cart-btn js-gp-cart-btn" role="link"
                          an-tr="nv00_gnb--cart-depth1" an-ca="navigation" an-ac="gnb"
                          an-la="cart">
                          <span className="hidden">Cart</span>
                          <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"
                            focusable="false">
                            <path
                              d="M72.848 70.25c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-35 0c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11c0-6.074 4.926-11 11-11zm35 7a4 4 0 10.002 8.001 4 4 0 00-.002-8.001zm-35 0a4 4 0 100 8 4 4 0 000-8zM13.892 3.75c2.287 0 4.376 1.55 5.058 3.72l.064.22 2.97 11.187h68.128a4.727 4.727 0 014.661 5.786l-.048.2-9.559 36.291c-.583 2.216-2.618 3.842-4.894 3.944l-.228.005H30.06c-2.287 0-4.377-1.55-5.06-3.72l-.063-.219-13.124-49.413-10.7.006-.004-8 12.782-.007zm72.03 23.127H24.108l8.027 30.226H77.96l7.962-30.226z">
                            </path>
                          </svg>
                          <span className="gnb__cart-in-number gnb-cart-count" aria-live="polite"
                            style={{ display: 'none' }}></span>
                        </a>
                      </li>
                      {!props.isLoggedIn ?
                        <li className="gnb__login before-login-context">
                          <a className="gnb__login-btn" href="#" onClick={e => e.preventDefault()} role="button"
                            aria-label="Log-In" aria-expanded="false">
                            <span className="hidden">Log-In</span>
                            <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"
                              focusable="false">
                              <path
                                d="M48 50c17.346 0 32 14.221 32 31.054V89c0 2.757-2.243 5-5 5H21c-2.757 0-5-2.243-5-5v-7.946C16 64.221 30.654 50 48 50zm0 8c-12.785 0-24 10.773-24 23.054V86h48v-4.946C72 68.773 60.785 58 48 58zm-.002-56c12.133 0 22.003 9.87 22.003 22.001C70 36.131 60.13 46 47.998 46c-12.13 0-21.997-9.869-21.997-21.999C26 11.87 35.867 2 47.998 2zm0 8c-7.718 0-13.997 6.281-13.997 14.001C34 31.72 40.28 38 47.998 38 55.718 38 62 31.72 62 24.001 62 16.281 55.719 10 47.998 10z">
                              </path>
                            </svg>
                          </a>
                          <div className="gnb__login-layer">
                            <ul className="gnb__utility-menu">
                              <li>
                                <a href="#" onClick={props.handleLoggin}
                                  data-linkinfo="https://account.samsung.com/accounts/v1/DCGLIN/signInGate"
                                  className="gnb__utility-link loginBtn"
                                  an-tr="nv00_gnb--text-depth2" an-ca="account" an-ac="gnb"
                                  an-la="login">Log-In/Sign-Up
                                  <span className="icon-wrap">
                                    <svg className="icon" xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 96 96" focusable="false">
                                      <path
                                        d="M48 50c17.346 0 32 14.221 32 31.054V89c0 2.757-2.243 5-5 5H21c-2.757 0-5-2.243-5-5v-7.946C16 64.221 30.654 50 48 50zm0 8c-12.785 0-24 10.773-24 23.054V86h48v-4.946C72 68.773 60.785 58 48 58zm-.002-56c12.133 0 22.003 9.87 22.003 22.001C70 36.131 60.13 46 47.998 46c-12.13 0-21.997-9.869-21.997-21.999C26 11.87 35.867 2 47.998 2zm0 8c-7.718 0-13.997 6.281-13.997 14.001C34 31.72 40.28 38 47.998 38 55.718 38 62 31.72 62 24.001 62 16.281 55.719 10 47.998 10z">
                                      </path>
                                    </svg>
                                  </span>
                                </a>
                              </li>

                              <li>
                                <a href="https://www.samsung.com/in/web/search-orders/"
                                  className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                  an-ca="account" an-ac="gnb" an-la="orders">
                                  Orders
                                </a>
                              </li>

                              <li>
                                <a href="//www.samsung.com/in/mypage/#myd05-product-registration"
                                  className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                  an-ca="account" an-ac="gnb" an-la="product registration">
                                  Product Registration

                                </a>
                              </li>
                            </ul>
                          </div>
                        </li>
                        :
                        <li className="gnb__logout after-login-context" >
                          <a className="gnb__logout-btn" href="#" onClick={e => e.preventDefault()} role="button"
                            aria-label="Log Out" aria-expanded="false">
                            <span className="hidden">Open My Menu</span>
                            <div className="image js-gnb-afterlogin-image" style={{ display: 'none' }}>
                              <img className="image__preview " data-src="" alt="" />
                              <img className="image__main " data-src="" alt="" />
                            </div>
                            <svg className="icon js-gnb-afterlogin-no-image"
                              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
                              focusable="false">
                              <g fill="none" fillRule="evenodd">
                                <g>
                                  <g transform="translate(-1380 -22) translate(1380 22)">
                                    <circle cx="18" cy="18" r="18" fill="#EEE" />
                                    <g fill="#000" fillRule="nonzero">
                                      <path
                                        d="M8 8.333c2.891 0 5.333 2.37 5.333 5.176v1.324c0 .46-.373.834-.833.834h-9c-.46 0-.833-.374-.833-.834V13.51c0-2.806 2.442-5.176 5.333-5.176zm0 1.334c-2.13 0-4 1.795-4 3.842v.824h8v-.824c0-2.047-1.87-3.842-4-3.842zM8 .333c2.022 0 3.667 1.645 3.667 3.667S10.022 7.667 8 7.667 4.333 6.022 4.333 4 5.978.333 8 .333zm0 1.334C6.713 1.667 5.667 2.713 5.667 4c0 1.287 1.046 2.333 2.333 2.333 1.286 0 2.333-1.046 2.333-2.333 0-1.287-1.047-2.333-2.333-2.333z"
                                        transform="translate(10 10)" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </a>
                          <div className="gnb__login-layer">
                            <a className="gnb__user-name"
                              href="https://account.samsung.com/membership/contents/profile/profile-gate"
                              an-tr="nv00_gnb--text-depth2" an-ca="account" an-ac="gnb"
                              an-la="user name">
                              <span className="gnb__user-image">
                                <div className="image js-gnb-afterlogin-image"
                                  style={{ display: 'none' }}>
                                  <img className="image__preview " data-src=""
                                    alt="" />
                                  <img className="image__main " data-src="" alt="" />
                                </div>
                                <svg className="icon js-gnb-afterlogin-no-image"
                                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"
                                  focusable="false">
                                  <g fill="none" fillRule="evenodd">
                                    <g>
                                      <g>
                                        <g
                                          transform="translate(-1216 -91) translate(1200 64) translate(16 27)">
                                          <circle cx="16" cy="16" r="16"
                                            fill="#EEE" />
                                          <g fill="#000" fillRule="nonzero">
                                            <path
                                              d="M8 8.333c2.891 0 5.333 2.37 5.333 5.176v1.324c0 .46-.373.834-.833.834h-9c-.46 0-.833-.374-.833-.834V13.51c0-2.806 2.442-5.176 5.333-5.176zm0 1.334c-2.13 0-4 1.795-4 3.842v.824h8v-.824c0-2.047-1.87-3.842-4-3.842zM8 .333c2.022 0 3.667 1.645 3.667 3.667S10.022 7.667 8 7.667 4.333 6.022 4.333 4 5.978.333 8 .333zm0 1.334C6.713 1.667 5.667 2.713 5.667 4c0 1.287 1.046 2.333 2.333 2.333 1.286 0 2.333-1.046 2.333-2.333 0-1.287-1.047-2.333-2.333-2.333z"
                                              transform="translate(8 8)" />
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                              </span>
                              {userDetails.given_name || ''} {userDetails.family_name || ''}
                            </a>

                            <ul className="gnb__utility-menu">
                              <li>
                                <a href="https://www.samsung.com/in/mypage/"
                                  className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                  an-ca="account" an-ac="gnb" an-la="my page">
                                  My Page
                                </a>
                              </li>

                              <li>
                                <a href="https://www.samsung.com/in/web/mypage/orders/"
                                  className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                  an-ca="account" an-ac="gnb" an-la="orders">
                                  Orders
                                </a>
                              </li>

                              <li>
                                <a href="https://www.samsung.com/in/web/mypage/wishlist/"
                                  className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                  an-ca="account" an-ac="gnb" an-la="wishlist">
                                  Wishlist
                                </a>
                              </li>

                              <li>
                                <a href="https://www.samsung.com/in/web/loyalty-home/"
                                  className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                  an-ca="account" an-ac="gnb" an-la="smart club">
                                  Smart Club
                                </a>
                              </li>

                              <li>
                                <a href="//www.samsung.com/in/mypage/#myd05-product-registration"
                                  className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                  an-ca="account" an-ac="gnb" an-la="product registration">
                                  Product Registration

                                </a>
                              </li>

                              <li>
                                <a href="https://r2.community.samsung.com/t5/India/ct-p/in?profile.language=en"
                                  className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                  an-ca="account" an-ac="gnb" an-la="community">
                                  Community
                                </a>
                              </li>

                              {/* <li>
                              <a href="#" onClick={e=>e.preventDefault()} className="gnb__utility-link logoutBtn"
                                an-tr="nv00_gnb--text-depth2" an-ca="account" an-ac="gnb"
                                an-la="logout">Log Out</a>
                            </li> */}
                            </ul>
                          </div>
                        </li>
                      }

                    </ul>
                    {/* <!--/* // utility menu : desktop --> */}

                    <div className="gnb__utility-mobile">
                      {!props.isLoggedIn ?
                        <ul className="gnb__utility-menu before-login-context">
                          <li>
                            <a href="" onClick={props.handleLoggin}
                              data-linkinfo="https://account.samsung.com/accounts/v1/DCGLIN/signInGate"
                              className="gnb__utility-link loginBtn" an-tr="nv00_gnb--text-depth2"
                              an-ca="account" an-ac="gnb" an-la="login">
                              Log-In/Sign-Up
                              <span className="icon-wrap">
                                <svg className="icon" xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 96 96" focusable="false">
                                  <path
                                    d="M48 50c17.346 0 32 14.221 32 31.054V89c0 2.757-2.243 5-5 5H21c-2.757 0-5-2.243-5-5v-7.946C16 64.221 30.654 50 48 50zm0 8c-12.785 0-24 10.773-24 23.054V86h48v-4.946C72 68.773 60.785 58 48 58zm-.002-56c12.133 0 22.003 9.87 22.003 22.001C70 36.131 60.13 46 47.998 46c-12.13 0-21.997-9.869-21.997-21.999C26 11.87 35.867 2 47.998 2zm0 8c-7.718 0-13.997 6.281-13.997 14.001C34 31.72 40.28 38 47.998 38 55.718 38 62 31.72 62 24.001 62 16.281 55.719 10 47.998 10z">
                                  </path>
                                </svg>
                              </span>
                            </a>
                          </li>

                          <li>
                            <a href="https://www.samsung.com/in/web/search-orders/"
                              className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                              an-ca="account" an-ac="gnb" an-la="orders">
                              Orders
                            </a>
                          </li>

                          <li>
                            <a href="//www.samsung.com/in/mypage/#myd05-product-registration"
                              className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                              an-ca="account" an-ac="gnb" an-la="product registration">
                              Product Registration

                            </a>
                          </li>

                          {/* <li>
                          <a href="https://www.samsungdigitalservicecenter.com/landing"
                            className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                            an-ca="account" an-ac="gnb" an-la="digital service center">
                            Digital Service Center
                          </a>
                        </li> */}

                        </ul>
                        : <>
                          <a className="gnb__user-name after-login-context"
                            href="https://account.samsung.com/membership/contents/profile/profile-gate"
                            an-tr="nv00_gnb--text-depth2" an-ca="account"
                            an-ac="gnb" an-la="user name">
                            <span className="gnb__user-image">
                              <div className="image js-gnb-afterlogin-image" style={{ display: 'none' }}>
                                <img className="image__preview " data-src="" alt="" />
                                <img className="image__main " data-src="" alt="" />
                              </div>
                              <svg className="icon js-gnb-afterlogin-no-image"
                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
                                focusable="false">
                                <g fill="none" fillRule="evenodd">
                                  <g>
                                    <g transform="translate(-1380 -22) translate(1380 22)">
                                      <circle cx="18" cy="18" r="18" fill="#EEE" />
                                      <g fill="#000" fillRule="nonzero">
                                        <path
                                          d="M8 8.333c2.891 0 5.333 2.37 5.333 5.176v1.324c0 .46-.373.834-.833.834h-9c-.46 0-.833-.374-.833-.834V13.51c0-2.806 2.442-5.176 5.333-5.176zm0 1.334c-2.13 0-4 1.795-4 3.842v.824h8v-.824c0-2.047-1.87-3.842-4-3.842zM8 .333c2.022 0 3.667 1.645 3.667 3.667S10.022 7.667 8 7.667 4.333 6.022 4.333 4 5.978.333 8 .333zm0 1.334C6.713 1.667 5.667 2.713 5.667 4c0 1.287 1.046 2.333 2.333 2.333 1.286 0 2.333-1.046 2.333-2.333 0-1.287-1.047-2.333-2.333-2.333z"
                                          transform="translate(10 10)" />
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </span>
                            {userDetails.given_name || ''} {userDetails.family_name || ''}
                          </a>

                          <ul className="gnb__utility-menu after-login-context" >
                            <li>
                              <a href="https://www.samsung.com/in/mypage/" className="gnb__utility-link"
                                an-tr="nv00_gnb--text-depth2" an-ca="account" an-ac="gnb"
                                an-la="my page">
                                My Page
                              </a>
                            </li>

                            <li>
                              <a href="https://www.samsung.com/in/web/mypage/orders/"
                                className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                an-ca="account" an-ac="gnb" an-la="orders">
                                Orders
                              </a>
                            </li>

                            <li>
                              <a href="https://www.samsung.com/in/web/mypage/wishlist/"
                                className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                an-ca="account" an-ac="gnb" an-la="wishlist">
                                Wishlist
                              </a>
                            </li>

                            <li>
                              <a href="https://www.samsung.com/in/web/loyalty-home/"
                                className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                an-ca="account" an-ac="gnb" an-la="smart club">
                                Smart Club
                              </a>
                            </li>

                            <li>
                              <a href="//www.samsung.com/in/mypage/#myd05-product-registration"
                                className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                an-ca="account" an-ac="gnb" an-la="product registration">
                                Product Registration

                              </a>
                            </li>

                            {/* <li>
                          <a href="https://www.samsungdigitalservicecenter.com/landing"
                            className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                            an-ca="account" an-ac="gnb" an-la="digital service center">
                            Digital Service Center
                          </a>
                        </li> */}

                            <li>
                              <a href="https://r2.community.samsung.com/t5/India/ct-p/in?profile.language=en"
                                className="gnb__utility-link" an-tr="nv00_gnb--text-depth2"
                                an-ca="account" an-ac="gnb" an-la="community">
                                Community
                              </a>
                            </li>

                            {/* <li>
                              <a href="#" onClick={e => e.preventDefault()} className="gnb__utility-link logoutBtn" an-tr="nv00_gnb--text-depth2" an-ca="account" an-ac="gnb" an-la="logout">Log Out</a>
                            </li> */}
                          </ul>
                        </>}
                    </div>
                    {/* /* // utility menu : mobile */}
                  </div>
                </div>
                <a className="gnb__menu-close" href="#" onClick={e => e.preventDefault()} role="button"
                  an-tr="nv00_gnb--image-action" an-ca="navigation" an-ac="gnb" an-la="gnb:close">
                  <span className="hidden">Close Menu</span>
                  <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"
                    focusable="false">
                    <path
                      d="M79.17 11.17L48 42.34 16.83 11.17l-5.66 5.66L42.34 48 11.17 79.17l5.66 5.66L48 53.66l31.17 31.17 5.66-5.66L53.66 48l31.17-31.17z">
                    </path>
                  </svg>
                </a>
              </div>

              <div className="gnb__mobile-dimmed" aria-hidden="true">
              </div>
              <div className="gnb__mobile-dimmed">
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};
export default Header